import VideoJsAdapter from "../../adapters/videojs_adapter";

export default class ProgressControl extends VideoJsAdapter.getComponent('ProgressControl') {
  hide(){
    this.addClass("vjs-progress-control--hidden");
  }

  show(){
    this.removeClass("vjs-progress-control--hidden");
  }
}

VideoJsAdapter.registerComponent('ProgressControl', ProgressControl);

